/**
 * Pure feature-scope gates for ErrorIsolationProbe (no import.meta — Jest-safe).
 */
export const ERROR_ISOLATION_PROBE_FEATURES = [
  'shell-outlet',
  'account',
  'checkout',
  'retail',
  'recovery',
] as const;

export type ErrorIsolationProbeFeature =
  (typeof ERROR_ISOLATION_PROBE_FEATURES)[number];

export function isErrorIsolationProbeFeature(
  value: string,
): value is ErrorIsolationProbeFeature {
  return (ERROR_ISOLATION_PROBE_FEATURES as readonly string[]).includes(value);
}

/**
 * Pure gate used by the probe component and unit tests.
 * Returns the known feature to throw for, or `null` to render nothing.
 */
export function resolveErrorIsolationProbeThrow(args: {
  isDev: boolean;
  isProd: boolean;
  flag: string | undefined;
  /** Only throw if the window flag equals this mount's feature. */
  mountFeature: ErrorIsolationProbeFeature;
}): ErrorIsolationProbeFeature | null {
  const { isDev, isProd, flag, mountFeature } = args;

  if (isProd && flag === undefined) {
    return null;
  }

  const active = isDev || flag !== undefined;
  if (!active) {
    return null;
  }

  if (
    flag !== undefined &&
    isErrorIsolationProbeFeature(flag) &&
    flag === mountFeature
  ) {
    return flag;
  }

  return null;
}

export interface ErrorIsolationProbeProps {
  readonly feature: ErrorIsolationProbeFeature;
}